<div class="loading-wrapper" [class.overlay]="overlay" [class.inline]="!overlay" *ngIf="loading$ | async">
    <div class="loading-content">
        <mat-spinner [diameter]="diameter"></mat-spinner>
        <p class="loading-message">{{ message }}</p>
    </div>
</div>